// src/redux/reducers/timesheetReducer.js
import {
    SET_TIMESHEET_LOADING,
    CLEAR_TIMESHEET_ERROR,

    FETCH_TIMESHEETS_SUCCESS,
    FETCH_TIMESHEETS_FAIL,

    GET_TIMESHEET_SUCCESS,
    GET_TIMESHEET_FAIL,

    CREATE_TIMESHEET_SUCCESS,
    CREATE_TIMESHEET_FAIL,

    UPDATE_TIMESHEET_SUCCESS,
    UPDATE_TIMESHEET_FAIL,

    DELETE_TIMESHEET_SUCCESS,
    DELETE_TIMESHEET_FAIL,

    FETCH_TIMESHEET_DAYS_SUCCESS,
    FETCH_TIMESHEET_DAYS_FAIL,

    UPSERT_TIMESHEET_DAY_SUCCESS,
    UPSERT_TIMESHEET_DAY_FAIL,

    DELETE_TIMESHEET_DAY_SUCCESS,
    DELETE_TIMESHEET_DAY_FAIL,
} from "../actions/timesheetActions";

const initialState = {
    timesheets: [],
    currentTimesheet: null,

    // { [timesheetId]: TimesheetDayResponseDTO[] }
    daysByTimesheetId: {},

    loading: false,
    error: null,
};

export default function timesheetReducer(state = initialState, action) {
    switch (action.type) {
        case SET_TIMESHEET_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_TIMESHEET_ERROR:
            return { ...state, error: null };

        // ===== LIST =====
        case FETCH_TIMESHEETS_SUCCESS:
            return { ...state, timesheets: action.payload || [], error: null };
        case FETCH_TIMESHEETS_FAIL:
            return { ...state, error: action.payload };

        // ===== GET ONE =====
        case GET_TIMESHEET_SUCCESS:
            return { ...state, currentTimesheet: action.payload, error: null };
        case GET_TIMESHEET_FAIL:
            return { ...state, error: action.payload };

        // ===== CREATE =====
        case CREATE_TIMESHEET_SUCCESS: {
            const created = action.payload;
            return {
                ...state,
                timesheets: [created, ...state.timesheets.filter((t) => t.id !== created?.id)],
                currentTimesheet: created,
                error: null,
            };
        }
        case CREATE_TIMESHEET_FAIL:
            return { ...state, error: action.payload };

        // ===== UPDATE =====
        case UPDATE_TIMESHEET_SUCCESS: {
            const updated = action.payload;
            return {
                ...state,
                timesheets: state.timesheets.map((t) => (t.id === updated?.id ? updated : t)),
                currentTimesheet: state.currentTimesheet?.id === updated?.id ? updated : state.currentTimesheet,
                error: null,
            };
        }
        case UPDATE_TIMESHEET_FAIL:
            return { ...state, error: action.payload };

        // ===== DELETE =====
        case DELETE_TIMESHEET_SUCCESS: {
            const id = action.payload;
            const next = state.timesheets.filter((t) => t.id !== id);
            const current = state.currentTimesheet?.id === id ? null : state.currentTimesheet;
            const days = { ...state.daysByTimesheetId };
            delete days[id];
            return { ...state, timesheets: next, currentTimesheet: current, daysByTimesheetId: days, error: null };
        }
        case DELETE_TIMESHEET_FAIL:
            return { ...state, error: action.payload };

        // ===== DAYS LIST =====
        case FETCH_TIMESHEET_DAYS_SUCCESS: {
            const { timesheetId, days } = action.payload || {};
            return {
                ...state,
                daysByTimesheetId: { ...state.daysByTimesheetId, [timesheetId]: days || [] },
                error: null,
            };
        }
        case FETCH_TIMESHEET_DAYS_FAIL:
            return { ...state, error: action.payload };

        // ===== UPSERT DAY =====
        case UPSERT_TIMESHEET_DAY_SUCCESS: {
            const row = action.payload; // TimesheetDayResponseDTO
            const tid = row?.timesheetId;
            if (!tid) return state;

            const prev = state.daysByTimesheetId[tid] || [];
            const idx = prev.findIndex((x) => x.id === row.id || (x.workDate === row.workDate));
            let next;
            if (idx >= 0) next = prev.map((x, i) => (i === idx ? row : x));
            else next = [row, ...prev];

            return {
                ...state,
                daysByTimesheetId: { ...state.daysByTimesheetId, [tid]: next },
                error: null,
            };
        }
        case UPSERT_TIMESHEET_DAY_FAIL:
            return { ...state, error: action.payload };

        // ===== DELETE DAY =====
        case DELETE_TIMESHEET_DAY_SUCCESS: {
            const { dayId, timesheetId } = action.payload || {};
            const prev = state.daysByTimesheetId[timesheetId] || [];
            return {
                ...state,
                daysByTimesheetId: {
                    ...state.daysByTimesheetId,
                    [timesheetId]: prev.filter((d) => d.id !== dayId),
                },
                error: null,
            };
        }
        case DELETE_TIMESHEET_DAY_FAIL:
            return { ...state, error: action.payload };

        default:
            return state;
    }
}
